import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import { AuthContext } from '../../auth/AuthContext';

import logo from '../../assets/imgs/icons/deer.png'
import BotonPerfil from './BotonPerfil';

import style from '../../assets/styles/ui/navbar.module.css'

const NavBar = () => {

    const { user } = useContext( AuthContext )

    return ( user &&
    
    <div className={ style.navbarContainer }>
        <nav className={ style.navbar }>

            <NavLink className={ style.navbarBrand} to={`/`} >
                <div className={ style.imageWrapper }>
                    <img src={logo} alt="" />
                </div>
                <p>Roof Events</p>
            </NavLink>

            <div className={ style.navbarCollapse } >

                <ul className={ style.navbarNav }>
                    {/* <li>
                        <NavLink
                            className={ style.navbarMenuItem }
                            to={`/organizador/dashboard`}>Dashboard</NavLink>
                    </li>
                    <li>
                        <NavLink 
                            className={ style.navbarMenuItem }
                            to={`/organizador/${ user._id }`}>Mi sitio</NavLink>
                    </li> */}
                </ul>


                <ul className={ style.navbarNav }>
                    <li>
                        { user.logged 
                            ? 
                                <BotonPerfil />  
                            :
                                <NavLink to="/login">Iniciar sesión</NavLink>
                        }
                    </li>
                </ul>

            </div>

        </nav>
    </div>)

}

export default NavBar;